

























import Vue from 'vue';
import { AxiosError } from 'axios';
import BaseModal from '@/components/BaseModal.vue';
import { user } from '@/services/api/userApi';
import { errorCodeFromAxiosError } from '@/models/ErrorCode';
import msg from '@/services/userMsg';
import { dispatch } from '@/services/store/utils';
import { GeneralAccount } from '@/models/accounts/GeneralAccount';
import { propOfType } from '@/services/utils';

export default Vue.extend({
  components: {
    BaseModal,
  },
  props: {
    onClose: propOfType<Function>((forceLogout: boolean) => {}),
  },
  data() {
    return {
      loading: false,
      phone: '',
      phoneIsValid: false,
      errorMessage: '',
    };
  },
  computed: {
    idCuentaCorporativa(): number | null {
      const account = this.$store.getters.selectedAccount as GeneralAccount | null;
      return account?.tag === 'corporateAccount' ? account.account.idCuentaSgv : null;
    },
    title(): string {
      return msg.getTitle('incompleteProfile');
    },
    description(): string {
      return msg.getModalContent('incompletePhone');
    },
  },
  methods: {
    onConfirm(): void {
      if (this.loading) return;

      if (!this.phone || !this.phoneIsValid) {
        this.errorMessage = msg.getModalContent('invalidPhone');
        return;
      }

      const { idCuentaCorporativa } = this;
      if (idCuentaCorporativa === null) return;

      this.errorMessage = '';
      this.loading = true;

      user.changePhone({ idCuentaCorporativa, phone: this.phone })
        .then(() => {
          dispatch('changedPhone', { idCuentaCorporativa, celular: this.phone });
          this.$toast.success(msg.getSuccess('phone_changed'));
          this.onClose(false);
        })
        .catch((error: AxiosError) => {
          this.errorMessage = msg.getError(errorCodeFromAxiosError(error));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onExit(): void {
      if (this.loading) return;
      this.onClose(true);
    },
  },
  watch: {
    phone(): void {
      this.errorMessage = '';
    },
  },
});
